<template>
  <div>
    <div class="box" :class="{ lighter }" @click="handleClick">
      {{ $props.label }}
    </div>
  </div>
</template>

<script>
export default {
  inject: ["getCheckList", "clickBox"],
  props: ["label", "value"],

  created() {
    console.log(this.$props, "props...");
    console.log(this.reactiveCheckList, "this.reactiveCheckList");
  },
  computed: {
    reactiveCheckList() {
      return this.getCheckList();
    },
    lighter() {
      if (Array.isArray(this.reactiveCheckList)) {
        if (Array.isArray(this.$props.value)) {
          return this.$props.value.some((_) =>
            this.reactiveCheckList.includes(_)
          );
        } else {
          return this.reactiveCheckList.includes(this.$props.value);
        }
      } else {
        console.log(this.reactiveCheckList, "lighrt");

        return this.reactiveCheckList == this.$props.value;
      }
    },
  },
  data() {
    return {};
  },

  methods: {
    handleClick() {
      this.clickBox(this.$props.value);
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  // width: 100rpx;
  height: 48px;
  background-color: #fbfbfb;
  text-align: left;
  font-size: 28px;
  color: #999999;
  line-height: 48px;
  text-align: center;
  border-radius: 7px 7px 7px 7px;
  white-space: nowrap; /* 确保文本在一行内显示 */
  overflow: hidden; /* 隐藏超出容器的文本 */
  text-overflow: ellipsis; /* 使用省略符号表示文本被截断 */
  box-sizing: border-box;
  border: 1px solid transparent;
}
.lighter {
  border: 1px solid #ea9052;
  color: #ea9052;
}
</style>
